import React from "react";

import type { LoginBanner } from "features/login/types";

import {
  Banner,
  ContentBanner,
  LinkBanner,
  TextBanner,
} from "./LoginPage.styles";

const ITEMS: LoginBanner[] = [
  {
    text: "Está entrando em um apartamento/loja com Medição Individual?",
    href: "/troca-titularidade?tab=2",
    linkText: "Realize a troca de titularidade",
  },
  {
    text: "Está saindo de um apartamento/loja com Medição Individual?",
    href: "/troca-titularidade?tab=1",
    linkText: "Solicite a suspensão",
  },
  {
    text: "Quer solicitar o Ligue ou Religue do seu gás?",
    href: "/troca-titularidade?tab=3",
    linkText: "Entenda e solicite",
  },
];

const LoginBanners = (): JSX.Element => (
  <ContentBanner>
    {ITEMS.map((item) => (
      <Banner key={item.href}>
        <TextBanner>{item.text}</TextBanner>
        <LinkBanner href={item.href}>{item.linkText}</LinkBanner>
      </Banner>
    ))}
  </ContentBanner>
);

export default LoginBanners;
